import { render, staticRenderFns } from "./DocsWrapper.vue?vue&type=template&id=ada993e6&"
import script from "./DocsWrapper.vue?vue&type=script&lang=ts&"
export * from "./DocsWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./DocsWrapper.vue?vue&type=style&index=0&id=ada993e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports